import React from "react"
import ReactDOM from "react-dom/client"
import axios from "axios"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
axios.defaults.baseURL = process.env.REACT_APP_BACKENDURL || "https://jsonplaceholder.typicode.com"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
